import styled from "styled-components";

export const GameNumberBadgeDefaultBox = styled.div<{isFontLoaded: boolean}>`
    font-size: 100px;
    line-height: 1;
    ${({theme}) => theme.font.presets.secondary};
    margin-right: -30px;
    color: ${props => props.theme.colors.backgroundDark};
    letter-spacing: -1rem;
    z-index: 2;
    text-shadow: -1px -1px 0 ${props => props.theme.colors.brandPrimary},
        1px -1px 0 ${props => props.theme.colors.brandPrimary},
        -1px 1px 0 ${props => props.theme.colors.brandPrimary},
        1px 1px 0 ${props => props.theme.colors.brandPrimary};

    /**
     * BUGFIX-1896215 https://dev.azure.com/888holdings/GamingNDL/_workitems/edit/1896215
     * In a scrolling container (in this case orbit swiper), the first animated icon loaded is above all elements (in this case the static image and the number badge)
     * When swiping, if the first animated icon gets out of the viewport and unloads, the problem is transfered to the second animation.
     * Yes, I know, the solution doesn't have any logic. But I tried this long shot and it worked:
     * https://css-tricks.com/forums/topic/safari-for-ios-z-index-ordering-bug-while-scrolling-a-page-with-a-fixed-element/
     * https://stackoverflow.com/questions/16033416/while-scrolling-on-an-ios-device-the-z-index-of-elements-isnt-working
     * https://stackoverflow.com/questions/9807620/ipad-safari-scrolling-causes-html-elements-to-disappear-and-reappear-with-a-dela
     */
    -webkit-transform: translate3d(0,0,0);
    /**
     * Because YES, Safari is the new Internet Explorer!!!
     */

    @media ${({theme}) => theme.mediaQuery.xlAndBelow} {
        margin-right: -17px;
    }

    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
        font-size: 75px;
        margin-right: -16px;
    }
`;
